import { Paper, Grid, Typography } from '@material-ui/core/';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Skeleton from '@material-ui/lab/Skeleton';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginTop: theme.spacing(4),
  },
  paperContainer: {
    padding: theme.spacing(3),
  },
  section: {
    marginTop: theme.spacing(2),
  },
}));

export default function Loading() {
  const classes = useStyles();

  return (
    <Grid className={classes.root} container>
      <Grid item xs={12}>
        <Paper className={classes.paperContainer} variant="outlined">
          <Grid justify="space-between" alignItems="center" container>
            <div>
              <Typography variant="subtitle2" color="primary">
                Performance graph
              </Typography>
            </div>
          </Grid>
          <Grid justify="space-between" alignItems="center" container className={classes.section}>
            <Skeleton variant="rect" width="100%" height={370} animation="wave" />
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
}
